var _image;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    xmlSpace: "preserve",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAB00lEQVR4Ae3BwZGkRhAAwOxrBzAHEzCnPOkoc/AAF2QGFkgPvRTszlAD7Olxmf74zZqfExjqEuEbzc8IDHWJ8ELzvMBQlwhvNM8KDHWJcELznMBQlwgnNc8IDHWJUNDcLzDUJUJRc6/AUJcIH2juExjqEuFDzT0CQ10iXNBcFxjqEuGi5prAUJcIN2g+FxjqEuEmzWcCQ10i3KipCwx1iXCzpiYw1CXCA5rzAkNdIjykOScw1CXCg5r3AkNdIjyseS0w1CXCD2i+FxjqEuEoMNQlwjearwWGukQ4Cgx1ifDCL/dJhKPAUJcIb3Rf27BjcU4iHAWGukQ4ofvehh2L1xLhKDDUJcJJ3Wsbdiy+lghHgaEuEQq69zbsWPxXIhwFhrpEKOrO2bBj8a9EOAoMdYnwge68DTv+QjgKDHWJ8KHmHoGhLhEuaK4LDHWJcFFzTWCoS4Qb/PJ7/O0m3TUbdixqZkxYXdRdt2HHombGhNUF3T027FjUzJiw+lB3nw07FjUzJqw+0N1rw45FzYwJq6Lufht2LGpmTFgVdM/YsGNRM2PC6qTuORt2LGpmTFid0D1rw45FzYwJqze6523YsaiZMWH1QvczNuxY1MyYsPrjf+ofmPt5c6Vnc/sAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.74af374ae1cc8af7e497e67427848c84.svg";
export { ForwardRef as ReactComponent };